
  <nav class="navbar navbar-light">
    <span class="ml-auto mr-auto">
      <a class="navbar-brand" routerLink="/">
        <img src="https://assets.cyberprotect.cloud/LOGO_ThreatScore-fondblc.png" height="75" alt="ThreatScore">
      </a>&nbsp;by&nbsp;<a class="navbar-brand" target="_blanck" href="https://www.cyberprotect.one">
        <img src="https://assets.cyberprotect.cloud/LOGO_Cyberprotect-fondblc.png" height="50" alt="Cyberprotect">
      </a>
    </span>
  </nav>
